import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";

import {useStoredSession} from "@/src/modules/auth/store/session";
import {useSessionEndStore} from "@/src/modules/auth/store/session-end";

import {PUBLIC_PATHS} from "../utils/constants";

export default function useRedirectToLogout() {
  const session = useStoredSession();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname.split("/")[1] ?? "/";
    if (useSessionEndStore.getState().sessionEnding) {
      return;
    }
    if (!session && !PUBLIC_PATHS.includes(pathname as (typeof PUBLIC_PATHS)[number])) {
      navigate("/logout");
    }
  }, [location.pathname, navigate, session]);
}
